<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="grid-container">
        <div class="item1 text-uppercase">
          <h6>{{ $t("teachers.detail.teacherDetails") }}</h6>
        </div>
        <div class="item2">
          <span class="text-uppercase">{{
            $t("teachers.detail.teacherName")
          }}</span
          ><span>: {{ teacher.name }}</span>
        </div>
        <div class="item3">
          <span class="text-uppercase">{{
            $t("teachers.detail.courseTitle")
          }}</span
          ><span>: {{ teacher.course }}</span>
        </div>
        <div class="item4">
          <img
            :src="
              teacher.image
                ? teacher.image
                : 'https://i.pravatar.cc/200?id=' + teacher.id
            "
            class="right-img"
          />
          <soft-badge
            color="warning"
            variant="gradient"
            size="sm"
            @click="$emit('close')"
            class="cursor-pointer close"
          >
            {{ $t("global.close") }}
          </soft-badge>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center justify-content-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 subcourse-title"
              >
                {{ $t("teachers.detail.subcourseTitle") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("teachers.detail.numberOfCandidate") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("teachers.detail.subcourseStartDate") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("teachers.pastMonths") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2"
              >
                {{ $t("teachers.detail.currentSubcourseProgress") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2"
              >
                {{ $t("teachers.detail.subcourseDuration") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in teacher.subcourses" :key="item.id">
              <td class="subcourse-title">
                {{ item.title }}
              </td>
              <td>
                <span class="text-xs font-weight-bold mb-0">
                  {{ item.kids_count }}
                </span>
              </td>
              <td>
                <span class="text-xs font-weight-bold">{{
                  item.start_date
                }}</span>
              </td>
              <td>
                <span class="text-xs font-weight-bold"
                  >{{ item.number_of_finished_months }}.</span
                >
              </td>
              <td class="align-middle text-center">
                <div class="d-flex align-items-center justify-content-center">
                  <span class="me-2 text-xs font-weight-bold"
                    >{{ item.course_progress }}%</span
                  >
                  <div>
                    <soft-progress
                      color="info"
                      variant="gradient"
                      :percentage="item.course_progress"
                    />
                  </div>
                </div>
              </td>
              <td class="align-middle ps-2">
                <span class="me-2 text-xs font-weight-bold"
                  >{{ item.number_of_months }}
                  {{ this.formatMonthsTitle(item.number_of_months) }}</span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import SoftProgress from "@/components/SoftProgress";
import SoftBadge from "@/components/SoftBadge.vue";

export default {
  name: "teacher-details",
  components: {
    SoftProgress,
    SoftBadge,
  },
  props: {
    teacher: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  methods: {
    formatMonthsTitle(numberOfMonths) {
      return numberOfMonths > 4
        ? this.$t("teachers.detail.months")
        : this.$t("teachers.detail.month");
    },
  },
};
</script>

<style scoped>
.right-img {
  position: relative;
  border: 1px solid gray;
  padding: 6px;
  border-radius: 8px;
  width: 120px !important;
  height: 120px !important;
  margin-left: 50%;
}
tr,
td {
  text-align: center;
  vertical-align: middle;
}
.subcourse-title {
  padding-left: 30px;
  text-align: left;
}
.item1 {
  grid-area: teacher-detail;
  height: 1px;
}
.item2 {
  grid-area: teachers-name;
  height: 3px;
  font-size: medium !important;
}
.item3 {
  grid-area: teachers-course;
  height: 3px;
  font-size: medium !important;
}
.item4 {
  grid-area: teachers-image;
}
.close {
  position: relative;
  float: right !important;
}
.grid-container {
  display: grid;
  grid-template-areas:
    "teacher-detail teacher-detail teacher-detail teacher-detail teachers-image teachers-image"
    "teachers-name teachers-name teachers-name teachers-name teachers-image teachers-image"
    "teachers-course teachers-course teachers-course teachers-course teachers-image teachers-image";
  gap: 1px;
  padding: 1px;
}
.grid-container > div {
  background-color: rgba(255, 255, 255, 0.8);
  text-align: left;
  padding: 5px 20px;
  font-size: 20px;
}
</style>
